<template>
    <div
        class="pointer-events-none absolute left-px right-px top-[49px] bottom-px overflow-hidden rounded-b-sm bg-white"
        data-testid="email-ai-loading-overlay"
    >
        <div
            class="absolute bottom-3 left-2 right-2 top-2 z-0 overflow-hidden rounded-md"
            data-testid="email-ai-loading-frame"
        >
            <ai-draft-loading-border testid-prefix="email-ai-loading" />
        </div>

        <div
            class="email-ai-loading-heading absolute left-7 top-6 flex items-center gap-1 font-semibold"
        >
            <icon data-testid="email-ai-loading-icon" name="regular/sparkles" />
            <span class="animate-pulse" data-testid="email-ai-loading-label">
                {{ $t('mailClient.aiDraft.generatingDraft') }}
                <span aria-hidden="true" class="ai-draft-loading-dots" />
            </span>
        </div>

        <div
            class="absolute left-5 right-5 top-16 flex flex-col gap-3"
            data-testid="email-ai-skeleton-preview"
        >
            <skeleton-loading class="h-4 w-2/3 rounded" />
            <skeleton-loading class="h-4 w-full rounded" />
            <skeleton-loading class="h-4 w-11/12 rounded" />
            <skeleton-loading class="h-4 w-3/4 rounded" />
        </div>

        <button
            class="pointer-events-auto absolute bottom-6 right-5 flex items-center justify-center gap-1.5 text-base font-normal text-black hover:text-blue-600"
            :aria-label="$t('mailClient.aiDraft.stopGeneration')"
            data-testid="email-ai-stop-button"
            type="button"
            @click="$emit('stop')"
        >
            <span>{{ $t('mailClient.aiDraft.stop') }}</span>
            <icon class="h-5 w-5" data-testid="email-ai-stop-icon" name="regular/ai-stop" />
        </button>
    </div>
</template>

<script setup lang="ts">
    import AiDraftLoadingBorder from '@/components/aiDraft/loading/AiDraftLoadingBorder.vue';
    import SkeletonLoading from '@/components/loading/SkeletonLoading.vue';
    import '@/components/aiDraft/loading/aiDraftLoadingDots.css';

    defineEmits<{
        stop: [];
    }>();
</script>

<style scoped>
    .email-ai-loading-heading {
        color: #0000ff;
    }
</style>
